import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { maximumEndcNrChartConfig } from '../chartConfigs';

/**
 * Props for the MaximumEndcNrEcharts component
 */
interface MaximumEndcNrEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Maximum ENDC Sessions Chart (NR Site Level)
 * 
 * Displays EN-DC (E-UTRAN New Radio - Dual Connectivity) session capacity metrics for NR sites:
 * - Maximum ENDC Users (count)
 * 
 * @component
 * @example
 * ```tsx
 * <MaximumEndcNrEcharts onFullscreenToggle={handleFullscreen} isFullscreen={false} />
 * ```
 * 
 * @see {@link ../chartConfigs.ts} - Chart configuration (maximumEndcNrChartConfig)
 * @see {@link ../../../components/SiteCharts/SiteCharts.tsx} - Template component
 * @see API: /api/nr/maximum-endc?site_name={siteName}
 */
const MaximumEndcNrEcharts: React.FC<MaximumEndcNrEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={maximumEndcNrChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default MaximumEndcNrEcharts;
